// extracted by mini-css-extract-plugin
export var searchHeader = "_3k-0";
export var searchHeaderDark = "_3k-1";